<template>
  <div>
    <PerfectScrollbar class="MaxWidthStylesheet">
      <div class="TopImageMaxWidthStylesheet">
        <div v-if="color" class="ShowOurIcon">
          <img src="../assets/img/lightL.jpg" alt="">
        </div>

        <div v-if="color1" class="ShowOurIcon">
          <img src="../assets/img/darkL.jpg" alt="">
        </div>

        <div style="position: absolute; left: 20px; top: 20px; z-index: 999999;" class="LanguageSwitcher">
          <VsxIcon @click="changeLanguage" iconName="Translate" :size="25" color="#000" type="linear" />
        </div>

        <div class="BottomTopImageMaxWidthStylesheet"></div>
        <div class="AnimationLoad">
          <div class="area" >
            <ul class="circles">
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
            </ul>
          </div >
        </div>
      </div>

   

      <div v-if="AllBox === 0" class="AllShowLogoInputAndLAbel">
        <form action="/LoginToSite12" method="post">
          <input type="hidden" name="_token" v-bind:value="csrf_token">

          <div class="ShowLogoInputAndLAbel">
            <label>{{ $t('login.email') }}</label>

            <div class="ShowAllNavBarStatus">
              <input autocomplete="off" v-model="email" type="text" name="email">
            </div>
          </div>

          <div v-if="errorMessage !== ''" class="ShowLogoInputAndLAbelCC">
            <span>{{ $t('login.errors.invalidEmail') }}</span>
            <div class="CercleShowLogoInputAndLAbel"></div>
          </div>

          <div class="ShowLogoInputAndLAbel">
            <label>{{ $t('login.password') }}</label>
            <div class="ShowAllNavBarStatus23">
              <input autocomplete="off" @keyup="ShowButton" v-model="password" :type="passwordFild" name="password">
              <div @click="ClickToShowDarkred" class="ClickToShowTextPassword">
                <svg v-if="passwordFild === 'text'" width="19" height="19" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 512 512">
                  <g>
                    <g>
                      <path d="m251.6,185.7c-36.9,0-67,31.5-67,70.3 0,38.7 30,70.3 67,70.3 36.9,0 67-31.5 67-70.3 0-38.7-30.1-70.3-67-70.3z"/>
                      <path d="m251.6,367.1c-59.4,0-107.8-49.8-107.8-111.1 0-61.3 48.4-111.1 107.8-111.1s107.8,49.8 107.8,111.1c0,61.3-48.4,111.1-107.8,111.1zm246.3-121.9c-63.8-102.4-149.8-158.8-241.9-158.8-92.1,0-178.1,56.4-241.9,158.8-4.1,6.6-4.1,15 0,21.6 63.8,102.4 149.8,158.8 241.9,158.8 92.1,0 178-56.4 241.9-158.8 4.1-6.6 4.1-15 0-21.6z"/>
                    </g>
                  </g>
                </svg>

                <svg v-if="passwordFild !== 'text'" width="19" height="19" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path d="M11.859 9h0.141c1.641 0 3 1.359 3 3v0.188zM7.547 9.797c-0.328 0.656-0.563 1.406-0.563 2.203 0 2.766 2.25 5.016 5.016 5.016 0.797 0 1.547-0.234 2.203-0.563l-1.547-1.547c-0.188 0.047-0.422 0.094-0.656 0.094-1.641 0-3-1.359-3-3 0-0.234 0.047-0.469 0.094-0.656zM2.016 4.266l1.266-1.266 17.719 17.719-1.266 1.266c-1.124-1.11-2.256-2.213-3.375-3.328-1.359 0.563-2.813 0.844-4.359 0.844-5.016 0-9.281-3.094-11.016-7.5 0.797-1.969 2.109-3.656 3.75-4.969-0.914-0.914-1.812-1.844-2.719-2.766zM12 6.984c-0.656 0-1.266 0.141-1.828 0.375l-2.156-2.156c1.219-0.469 2.578-0.703 3.984-0.703 5.016 0 9.234 3.094 10.969 7.5-0.75 1.875-1.922 3.469-3.422 4.734l-2.906-2.906c0.234-0.563 0.375-1.172 0.375-1.828 0-2.766-2.25-5.016-5.016-5.016z"/>
                </svg>
              </div>
            </div>
          </div>

          <div @click="AllBox = 1" class="ShowForgotPasswordLogoInputAndLAbel">
            <span>{{ $t('login.forgotPassword.clickHere') }}</span>
            <p>{{ $t('login.forgotPassword.forgotPasswordText') }}</p>
          </div>

          <div @click="onShow" class="ShowLogoInputAndLAbel23">
            {{ $t('login.login') }}
          </div>
        </form>


        <router-link to="/register" class="ShowTextForCreateAccount">
          <div>{{ $t('login.createAccount.createOne') }}</div>
          <span>{{ $t('login.createAccount.noAccount') }}</span>
        </router-link>
      </div>
      <div v-if="AllBox === 1" class="AllShowLogoInputAndLAbel">
        <div class="TopTitleAllShowLogoInputAndLAbel">
          {{ $t('login.forgotPassword.chooseMethod') }}
        </div>
        
        <div class="TabTopAllShowLogoInputAndLAbel">
          <div class="ShowLogoInputAndLAbel">
            <label>{{ $t('login.email') }}</label>
            <div class="ShowAllNavBarStatus">
              <input onkeypress="return /[a-z , 0-9 , '.' , '_' ,'-','@']/i.test(event.key)" autocomplete="off" for="email" @keyup="ShowButtonEmail" @blur="validateEmail" v-model="email" type="email" name="email">
              <div v-if="ShowTikEmail === true" class="ShowToOtherPeople">
                <i class="icon-checkmark"></i>
              </div>

              <div v-if="ShowTikEmail === false" class="ShowToOtherPeople">
                <i style="color: darkred;" class="icon-remove"></i>
              </div>
            </div>
          </div>

          <div v-if="ShowTikEmailOn === true" class="ShowLogoInputAndLAbelCC">
            <div class="CercleShowLogoInputAndLAbel"></div>
            <span>{{ $t('login.errors.emailRegistered') }}</span>
          </div>
          <div v-if="errorMessage !== ''" class="ShowLogoInputAndLAbelCC">
            <div class="CercleShowLogoInputAndLAbel"></div>
            <span>{{ $t('login.errors.invalidEmail') }}</span>
          </div>

          <div class="BottomShowCercleShowLogoInputAndLAbel">
            <div @click="AllBox = 0" class="divBackBottomShowCercleShowLogoInputAndLAbel">{{ $t('login.forgotPassword.back') }}</div>

            <button @click="sendForgotPasswordRequest" v-if="BtnSendEmail && !isLoading" class="BottomShowOneShowLogoInputAndLAbel">{{ $t('login.forgotPassword.sendCode') }}</button>
            <button v-if="BtnSendEmail && isLoading" class="BottomShowOneShowLogoInputAndLAbel">
              <span class="loading-indicator">در حال ارسال...</span>
            </button>
            <button v-if="!BtnSendEmail" class="BottomShowTwoShowLogoInputAndLAbel">{{ $t('login.forgotPassword.sendCode') }}</button>
          </div>
        </div>
      </div>
      <div v-if="AllBox === 2" class="AllShowLogoInputAndLAbel">
        <div class="TopTitleAllShowLogoInputAndLAbel">
          {{ $t('login.verifyCode.title') }}
        </div>

        <div class="InputAllShowLogoInputAndLAbelSend">
          <input onkeypress="return /[۰-۹ , 0-9]/i.test(event.key)" minlength="0" maxlength="6" type="text" v-model="codeSend" name="code" :placeholder="$t('login.forgotPassword.enterCode')">
        </div>

        <div v-if="ShowErrCode === true" class="ShowLogoInputAndLAbelCC">
          <div class="CercleShowLogoInputAndLAbel"></div>
          <span>{{ $t('login.verifyCode.invalidCode') }}</span>
        </div>
        
        <div class="BottomShowCercleShowLogoInputAndLAbel">
          <div @click="AllBox = 1" class="divBackBottomShowCercleShowLogoInputAndLAbel">{{ $t('login.forgotPassword.back') }}</div>
          <button @click="verifyForgotPasswordCode" class="BottomShowOneShowLogoInputAndLAbel">{{ $t('login.verifyCode.verify') }}</button>
        </div>
      </div>

      
      <div v-if="AllBox === 3" class="AllShowLogoInputAndLAbel">
        <div class="TopTitleAllShowLogoInputAndLAbel">
          {{ $t('login.resetPassword.title') }}
        </div>

        <div class="ShowLogoInputAndLAbel">
          <label>{{ $t('login.resetPassword.newPassword') }}</label>
          <div class="ShowAllNavBarStatus23">
            <input @keyup="showScore" v-model="passwordOne" :type="passwordFild" name="password">
            <div @click="ClickToShowDarkred" class="ClickToShowTextPassword">
              <svg v-if="passwordFild === 'text'" width="19" height="19" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 512 512">
                <g>
                  <g>
                    <path d="m251.6,185.7c-36.9,0-67,31.5-67,70.3 0,38.7 30,70.3 67,70.3 36.9,0 67-31.5 67-70.3 0-38.7-30.1-70.3-67-70.3z"/>
                    <path d="m251.6,367.1c-59.4,0-107.8-49.8-107.8-111.1 0-61.3 48.4-111.1 107.8-111.1s107.8,49.8 107.8,111.1c0,61.3-48.4,111.1-107.8,111.1zm246.3-121.9c-63.8-102.4-149.8-158.8-241.9-158.8-92.1,0-178.1,56.4-241.9,158.8-4.1,6.6-4.1,15 0,21.6 63.8,102.4 149.8,158.8 241.9,158.8 92.1,0 178-56.4 241.9-158.8 4.1-6.6 4.1-15 0-21.6z"/>
                  </g>
                </g>
              </svg>

              <svg v-if="passwordFild !== 'text'" width="19" height="19" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M11.859 9h0.141c1.641 0 3 1.359 3 3v0.188zM7.547 9.797c-0.328 0.656-0.563 1.406-0.563 2.203 0 2.766 2.25 5.016 5.016 5.016 0.797 0 1.547-0.234 2.203-0.563l-1.547-1.547c-0.188 0.047-0.422 0.094-0.656 0.094-1.641 0-3-1.359-3-3 0-0.234 0.047-0.469 0.094-0.656zM2.016 4.266l1.266-1.266 17.719 17.719-1.266 1.266c-1.124-1.11-2.256-2.213-3.375-3.328-1.359 0.563-2.813 0.844-4.359 0.844-5.016 0-9.281-3.094-11.016-7.5 0.797-1.969 2.109-3.656 3.75-4.969-0.914-0.914-1.812-1.844-2.719-2.766zM12 6.984c-0.656 0-1.266 0.141-1.828 0.375l-2.156-2.156c1.219-0.469 2.578-0.703 3.984-0.703 5.016 0 9.234 3.094 10.969 7.5-0.75 1.875-1.922 3.469-3.422 4.734l-2.906-2.906c0.234-0.563 0.375-1.172 0.375-1.828 0-2.766-2.25-5.016-5.016-5.016z"/>
              </svg>
            </div>
          </div>
        </div>
        
        <div class="ShowLogoInputAndLAbel">
          <label>{{ $t('login.resetPassword.confirmPassword') }}</label>
          <div class="ShowAllNavBarStatus23">
            <input @keyup="ShowButtonPassword" v-model="password2" :type="passwordFildD" name="password">
            <div v-if="ShowTikPas2 === true" class="ShowToOtherPeople">
              <i class="icon-checkmark"></i>
            </div>

            <div v-if="ShowTikPas2 === false" class="ShowToOtherPeople">
              <i style="color: darkred;" class="icon-remove"></i>
            </div>

            <div @click="ClickToShowDarkreds" class="ClickToShowTextPassword">
              <svg v-if="passwordFildD === 'text'" width="19" height="19" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 512 512">
                <g>
                  <g>
                    <path d="m251.6,185.7c-36.9,0-67,31.5-67,70.3 0,38.7 30,70.3 67,70.3 36.9,0 67-31.5 67-70.3 0-38.7-30.1-70.3-67-70.3z"/>
                    <path d="m251.6,367.1c-59.4,0-107.8-49.8-107.8-111.1 0-61.3 48.4-111.1 107.8-111.1s107.8,49.8 107.8,111.1c0,61.3-48.4,111.1-107.8,111.1zm246.3-121.9c-63.8-102.4-149.8-158.8-241.9-158.8-92.1,0-178.1,56.4-241.9,158.8-4.1,6.6-4.1,15 0,21.6 63.8,102.4 149.8,158.8 241.9,158.8 92.1,0 178-56.4 241.9-158.8 4.1-6.6 4.1-15 0-21.6z"/>
                  </g>
                </g>
              </svg>

              <svg v-if="passwordFildD !== 'text'" width="19" height="19" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M11.859 9h0.141c1.641 0 3 1.359 3 3v0.188zM7.547 9.797c-0.328 0.656-0.563 1.406-0.563 2.203 0 2.766 2.25 5.016 5.016 5.016 0.797 0 1.547-0.234 2.203-0.563l-1.547-1.547c-0.188 0.047-0.422 0.094-0.656 0.094-1.641 0-3-1.359-3-3 0-0.234 0.047-0.469 0.094-0.656zM2.016 4.266l1.266-1.266 17.719 17.719-1.266 1.266c-1.124-1.11-2.256-2.213-3.375-3.328-1.359 0.563-2.813 0.844-4.359 0.844-5.016 0-9.281-3.094-11.016-7.5 0.797-1.969 2.109-3.656 3.75-4.969-0.914-0.914-1.812-1.844-2.719-2.766zM12 6.984c-0.656 0-1.266 0.141-1.828 0.375l-2.156-2.156c1.219-0.469 2.578-0.703 3.984-0.703 5.016 0 9.234 3.094 10.969 7.5-0.75 1.875-1.922 3.469-3.422 4.734l-2.906-2.906c0.234-0.563 0.375-1.172 0.375-1.828 0-2.766-2.25-5.016-5.016-5.016z"/>
              </svg>
            </div>
          </div>
        </div>
        
        <div v-if="passwordOffTwo" class="ShowLogoInputAndLAbelCC">
          <div class="CercleShowLogoInputAndLAbel"></div>
          <span>{{ $t('login.errors.passwordTooShort') }}</span>
        </div>
        <div v-if="passwordOff" class="ShowLogoInputAndLAbelCC">
          <div class="CercleShowLogoInputAndLAbel"></div>
          <span>{{ $t('login.errors.passwordMismatch') }}</span>
        </div>
        
        <div v-if="BoxShowVV" class="ShowLogoInputAndLAbel5434">
          <button @click="resetPasswordSubmit">{{ $t('login.resetPassword.submit') }}</button>
        </div>
        <div v-if="!BoxShowVV" class="ShowLogoInputAndLAbel23">
          <button>{{ $t('login.resetPassword.submit') }}</button>
        </div>
      </div>

      <Vcode 
        :show="isShow" 
        @success="onSuccess" 
        @close="onClose"
        successText="تایید شد!"
        failText="تایید نشد، لطفا دوباره تلاش کنید"
        sliderText=" تکمیل تایید"
        :zIndex="999"
      />
    </PerfectScrollbar>


    <div v-if="ShowUser" class="ShowUserAllFixedRed">
      <div class="KShowUserAllFixedRed">
        <div class="TitleWelcome">
          خوش  آمدید !
        </div>
        
        <div class="CenterShowUserAllFixedRed">
         
          <div class="BtnCenterShowUserAllFixedRed1">
            <div style="background: #F3CB24;" class="BtnCenterShowUserAllFixedRed">
              <VsxIcon iconName="UserTick" :size="50" color="#fff" type="linear" />
            </div>
            <p>حساب کاربری دارید</p>  

            <div @click="ShowUser = false" style="background: #F2A900;" class="BtnUserTick">
              ورود
            </div>
          </div>


          <div class="BtnCenterShowUserAllFixedRed1">
            <div style="background: #3FB082;" class="BtnCenterShowUserAllFixedRed">
              <VsxIcon iconName="UserAdd" :size="50" color="#fff" type="linear" />
            </div>
            <p>حساب کاربری ندارید؟</p>

            <router-link to="/register">
              <div style="background: #3FB082;" class="BtnUserTick">
                ثبت نام
              </div>
            </router-link>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PerfectScrollbar } from 'vue3-perfect-scrollbar'
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import { mapActions } from 'vuex';
import Vcode from 'vue3-puzzle-vcode';
import axios from "@/axios";

export default {
  name: "loginUser",
  components: {
    Vcode,
    PerfectScrollbar
  },
  props : ['csrf_token'],
  data(){
    return{
      ShowUser: false,

      AllBox : 0,
      AllBoxTab : 0,
      BoxShowVV : false,
      isShow: false,
      BtnSend : false,
      BtnSendEmail : true,
      isLoading: false,

      BoxShow : false,
      UserCount : '',
      ClickStyle1 : '',
      ClickStyle2 : '',
      UserLength : 0,
      UserAlarm : '',
      PasswordAlarm : '',
      passwordFild : 'password',
      passwordFildD : 'password',
      numberTitle : '',
      NumberAlarm : '',
      NumberCheck : '',
      ShowTikEmail : '',
      ShowTikEmailOn : '',
      errorMessage: '',
      ShowErr: '90',
      ShowTikPas2 : '',
      passwordOff : false,
      passwordOffTwo : false,
      ShowErrCode: false,
      codeSend: '',
      resetKey: '',
      resetValue: '',
      resetToken: '',

      username : '',
      password : '',
      number : '',
      email : '',
      styleNavBar : '',

      passwordOne : '',
      password2 : '',
      color : false,
      color1 : false,
      color2 : '',
      color3 : '',
    }
  },
  computed: {
    currentLang() {
      return this.$store.state.currentLang;
    },
    theme() {
      return this.$store.state.theme;
    }
  },
  methods:{
    ...mapActions(['login']),
    onShow() {
      this.isShow = true;
    },
    onClose() {
      this.isShow = false;
    },
    onSuccess() {
      this.onClose();
      this.LoginToSite()
    },
    // Convert Persian/Arabic numbers to English
    convertToEnglishNumbers(str) {
      if (!str) return str;
      
      const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
      const arabicNumbers = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
      const englishNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
      
      let result = str;
      
      // Convert Persian numbers
      persianNumbers.forEach((persianNum, index) => {
        result = result.replace(new RegExp(persianNum, 'g'), englishNumbers[index]);
      });
      
      // Convert Arabic numbers
      arabicNumbers.forEach((arabicNum, index) => {
        result = result.replace(new RegExp(arabicNum, 'g'), englishNumbers[index]);
      });
      
      return result;
    },

    async LoginToSite(){
      try {
        // Convert Persian/Arabic numbers to English before sending
        const englishEmail = this.convertToEnglishNumbers(this.email);
        const englishPassword = this.convertToEnglishNumbers(this.password);
        
        const response = await this.login({ email: englishEmail, password: englishPassword });

        if (response == "wrong"){
          toast(this.$t('login.errors.wrongCredentials'), {
            autoClose: 3000,
            position: "top-right",
            type: "error",
          });
        }else {
          this.$router.push({ name: 'IndexUser' });
        }

      } catch (error) {
        console.error('blocked');
      }
    },

    validateEmail() {
      // در اینجا ما اعتبارسنجی را خاموش می‌کنیم تا کاربر بتواند هر ایمیلی را وارد کند
      this.errorMessage = '';
      this.ShowTikEmailOn = false;
      
      if (!this.email || this.email.trim() === '') {
        this.ShowTikEmail = false;
      } else {
        // نمایش تیک برای هر ایمیلی که خالی نباشد
        this.ShowTikEmail = true;
      }
      
      // همیشه true برگردان تا فرم بتواند ارسال شود
      return true;
    },
    ClickToShowDarkred () {
      if(this.passwordFild === 'password'){
        this.passwordFild = 'text'
      }else {
        this.passwordFild = 'password'
      }
    },
    loadTheme() {
      const savedTheme = localStorage.getItem('theme');
      if(savedTheme == "light"){
        this.color = true
        this.color1 = false
        this.color2 = 'background: #3C278E; color: #E7DFFF'
        this.color3 = 'background: #E7DFFF; color: #000'
      }else{
        this.color = false
        this.color1 = true
        this.color2 = 'background: #000; color: #fff'
        this.color3 = 'background: #121212; color: #fff'
      }
    },
    changeLanguage() {
      const newLang = this.currentLang === 'fa' ? 'en' : 'fa';
      this.$store.dispatch('changeLanguage', newLang);

      this.$i18n.locale = newLang;

      document.documentElement.dir = newLang === 'fa' ? 'rtl' : 'ltr';
      document.body.dir = newLang === 'fa' ? 'rtl' : 'ltr';
    },

    loadLanguage() {
      this.$i18n.locale = this.currentLang;
      document.documentElement.dir = this.currentLang === 'fa' ? 'rtl' : 'ltr';
      document.body.dir = this.currentLang === 'fa' ? 'rtl' : 'ltr';
    },
    ShowButtons() {
      if (this.number.length === 11) {
        this.BtnSend = true;
        this.NumberAlarm = false;
      } else {
        this.BtnSend = false;
        this.NumberAlarm = true;
      }
    },
    ShowButtonEmail() {
      // دکمه ارسال کد همیشه فعال باشد
      this.BtnSendEmail = true;
      
      // نمایش تیک برای ایمیل‌های غیر خالی
      if (this.email && this.email.trim() !== '') {
        this.ShowTikEmail = true;
      } else {
        this.ShowTikEmail = false;
      }
      
      // پاک کردن پیام خطا
      this.errorMessage = '';
    },
    ShowButton() {
      // For login password field
      this.BtnSend = this.password.length > 0;
      
      // For reset password fields
      if (this.passwordOne && this.password2) {
        if (this.passwordOne === this.password2 && this.passwordOne.length > 6) {
          this.BoxShowVV = true;
          this.passwordOff = false;
          this.passwordOffTwo = false;
        } else {
          this.BoxShowVV = false;
          
          if (this.passwordOne !== this.password2) {
            this.passwordOff = true;
          } else {
            this.passwordOff = false;
          }
          
          if (this.passwordOne.length <= 6) {
            this.passwordOffTwo = true;
          } else {
            this.passwordOffTwo = false;
          }
        }
      }
    },
    ShowButtonPassword() {
      if (this.passwordOne === this.password2 && this.passwordOne.length > 6) {
        this.BoxShowVV = true;
        this.ShowTikPas2 = true;
        this.passwordOff = false;
        this.passwordOffTwo = false;
      } else {
        this.BoxShowVV = false;
        this.ShowTikPas2 = false;
        
        if (this.passwordOne !== this.password2) {
          this.passwordOff = true;
        } else {
          this.passwordOff = false;
        }
        
        if (this.passwordOne.length <= 6) {
          this.passwordOffTwo = true;
        } else {
          this.passwordOffTwo = false;
        }
      }
    },
    showScore() {
      // فقط بررسی طول رمز عبور
      const password = this.passwordOne;
      
      // اگر طول رمز عبور بیشتر از 6 کاراکتر باشد، قوی در نظر گرفته می‌شود
      if (password.length > 6) {
        this.ShowErr = 3; // رمز عبور قوی
      } else {
        this.ShowErr = 0; // رمز عبور ضعیف
      }
      
      this.ShowButtonPassword(); // بروزرسانی وضعیت دکمه
    },
    ClickToShowDarkreds() {
      if (this.passwordFildD === 'password') {
        this.passwordFildD = 'text';
      } else {
        this.passwordFildD = 'password';
      }
    },
    // Forgot password methods
    async sendForgotPasswordRequest() {
      // اگر در حال لودینگ هستیم، درخواست جدید را نپذیر
      if (this.isLoading) {
        return;
      }
      
      // فقط چک کن که ایمیل خالی نباشد
      if (!this.email || this.email.trim() === '') {
        this.errorMessage = this.$t('login.errors.invalidEmail');
        return;
      }
      
      // Convert Persian/Arabic numbers to English
      const englishEmail = this.convertToEnglishNumbers(this.email);

      // پاک کردن پیام خطا قبل از ارسال درخواست
      this.errorMessage = '';
      
      try {
        this.isLoading = true; // شروع لودینگ
        
        const response = await axios.post('/forgot-password-request', {
          email: englishEmail
        });
        
        console.log('Forgot password response:', response.data);
        
        if (response.data) {
          this.resetKey = response.data.key || '';
          this.resetValue = response.data.value || '';
          this.AllBox = 2; // Move to verification code input
          toast(response.data.message || 'کد بازیابی به ایمیل شما ارسال شد', {
            autoClose: 3000,
            position: "top-right",
            type: "success",
          });
        }
      } catch (error) {
        console.error('Error sending forgot password request:', error);
        
        // نمایش پیام خطا از سرور
        let errorMessage = 'خطا در ارسال درخواست بازیابی رمز عبور';
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        
        toast(errorMessage, {
          autoClose: 3000,
          position: "top-right",
          type: "error",
        });
      } finally {
        this.isLoading = false; // پایان لودینگ
      }
    },
    async verifyForgotPasswordCode() {
      if (!this.codeSend || this.codeSend.length !== 6) {
        this.ShowErrCode = true;
        return;
      }

      try {
        // Convert Persian/Arabic numbers to English
        const englishCode = this.convertToEnglishNumbers(this.codeSend);
        
        const response = await axios.post('/verify-forgot-password-code', {
          code: englishCode,
          key: this.resetKey,
          value: this.resetValue
        });
        
        console.log('Verify code response:', response.data);
        
        if (response.data) {
          this.resetToken = response.data.reset_token || '';
          this.AllBox = 3; // Move to reset password screen
          toast(response.data.message || 'کد تایید شد', {
            autoClose: 3000,
            position: "top-right",
            type: "success",
          });
        }
      } catch (error) {
        console.error('Error verifying code:', error);
        this.ShowErrCode = true;
        
        let errorMessage = 'کد وارد شده نامعتبر است';
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        
        toast(errorMessage, {
          autoClose: 3000,
          position: "top-right",
          type: "error",
        });
      }
    },
    async resetPasswordSubmit() {
      if (this.passwordOne.length <= 6) {
        toast(this.$t('login.errors.passwordTooShort'), {
          autoClose: 3000,
          position: "top-right",
          type: "error",
        });
        return; // Password too short
      }
      
      if (this.passwordOne !== this.password2) {
        this.passwordOff = true;
        toast(this.$t('login.errors.passwordMismatch'), {
          autoClose: 3000,
          position: "top-right",
          type: "error",
        });
        return;
      }

      try {
        // Convert Persian/Arabic numbers to English
        const englishPassword = this.convertToEnglishNumbers(this.passwordOne);
        const englishPasswordConfirm = this.convertToEnglishNumbers(this.password2);
        
        const response = await axios.post('/reset-password', {
          reset_token: this.resetToken,
          password: englishPassword,
          password_confirmation: englishPasswordConfirm
        });
        
        console.log('Reset password response:', response.data);
        
        if (response.data) {
          // پاک کردن مقادیر رمز عبور
          this.passwordOne = '';
          this.password2 = '';
          this.BoxShowVV = false;
          
          // نمایش پیام موفقیت
          toast(this.$t('login.successMessages.passwordResetSuccess'), {
            autoClose: 3000,
            position: "top-right",
            type: "success",
          });
          
          // برگشت به صفحه ورود
          setTimeout(() => {
            this.AllBox = 0; // رفتن به صفحه ورود
          }, 1000);
        }
      } catch (error) {
        console.error('Error resetting password:', error);
        
        let errorMessage = this.$t('login.errors.resetPasswordError');
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        
        toast(errorMessage, {
          autoClose: 3000,
          position: "top-right",
          type: "error",
        });
      }
    },
  },
  watch: {
    email(value){
      this.email = value;
      this.validateEmail();
      this.ShowButtonEmail();
    },
  },
  mounted(){
    const savedTheme = localStorage.getItem('theme');
    if(savedTheme == "light"){
      this.ClickStyle1 = 'background: #3C278E; color: #E7DFFF'
    }else{
      this.ClickStyle1 = 'background: #000; color: #E7DFFF'
    }
    this.loadLanguage();
    this.loadTheme()
    setInterval(() => {
      this.loadTheme()
    }, 100);
  }
}
</script>

<style scoped>
.ShowUserAllFixedRed{
  position: fixed;
  right: 0;
  left: 0;
  bottom: 0;
  top: 0;
  background: #D3C5FF;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-indicator {
  display: inline-block;
  position: relative;
}

.loading-indicator:after {
  content: '...';
  display: inline-block;
  animation: loading-dots 1.5s infinite;
}

@keyframes loading-dots {
  0% { content: '.'; }
  33% { content: '..'; }
  66% { content: '...'; }
  100% { content: '.'; }
}

.CenterShowUserAllFixedRed{
  width: 330px;
  margin: auto;
  border-radius: 5px;
  display: grid;
  grid-template-columns: auto auto;
  gap: 10%;
  justify-content: center;
}

.BtnCenterShowUserAllFixedRed{
  background: #fff;
  height: 120px;
  width: 120px;
  border-radius: 100%;
  text-align: center;
  padding-top: 30px;
}

.TitleWelcome{
  text-align: center;
  font-size: 1.4rem;
  font-family: "iranyekanB";
  margin-bottom: 20px;
}

.BtnCenterShowUserAllFixedRed1{
  text-align: center;
  p{
    font-size: .9rem;
    font-family: "iranyekanB";
    margin-top: 20px;
  }
}

.BtnUserTick{
  height: 40px;
  width: 100%;
  border-radius: 5px;
  text-align: center;
  line-height: 37px;
  color: #fff;
  margin-top: 20px;
  font-size: 1rem;
  cursor: pointer;
}
</style>

